import React, {useEffect} from 'react';
import AfterHeader from './AfterHeader';
import LandingLayout from './Layout';
import { useWindowResize } from 'frontend-core';

const Blog: React.FC = () => {
  const [width] = useWindowResize();

  useEffect(() => {
    let iFrame = document.getElementById('blog-iframe') as HTMLIFrameElement;
    let pageWidth = document.body.scrollWidth;
    if (iFrame) {
      if (pageWidth >= 992) {
        iFrame.height = '1750px';
      }
      else if (768 <= pageWidth && pageWidth < 992) {
        iFrame.height =  `${2350 - ((992 - pageWidth) * 1.56)}px`;
      }
      else {
        iFrame.height =  `${5750 - ((768 - pageWidth) * 4.89)}px`;
      }
    }
    console.log('width changed', document.body.scrollWidth);
  }, [width]);

  return (
    <LandingLayout>
      <div className="blog">
        <AfterHeader
          title="Resources"
          caption="Blitz Blog"
        />

        <iframe
          id="blog-iframe"
          className="blog-iframe"
          src="https://blog.useblitz.com/resources/blog"
        />

      </div>
    </LandingLayout>
  );
};

export default Blog;
